import $ from 'jquery'
import Vivus from 'vivus'

const sleep = (ms = 0) => new Promise(resolve => setTimeout(resolve, ms))

if (!navigator.userAgent.match(/(iPhone|iPad|Android)/)) {
  $(window).on("load", async () => {
    $(".k-visual").removeClass("preload")
    $(".k-visual").addClass("is-loaded")
    $(".g-line").css("opacity", "1")
    await sleep(1000)
    $(".g-box").addClass("is-show")
    $(".bangumi-btn").addClass("is-show")
    $(".kv-gumi-wrap").css("opacity", "1")
    $(".kv-gumi").css("opacity", "1")
    const line = new Vivus('line', { type: 'scenario-sync', duration: 40, forceRender: false, animTimingFunction: Vivus.EASE })
    await sleep(600)
    $(".kv-button").addClass("is-affordance")
    await sleep(500)
    $(".p-header-menu").fadeIn(600)
    $(".p-side-bar").fadeIn(600)
    $(".k-visual__logo").css("opacity", 1).on("transitionend", (e) => {
      $(e.target).off("transitionend")
      $(".k-visual").addClass("is-finish")
    })
  })  
} else {
  $(window).on("load", async () => {
    $(".k-visual").removeClass("preload")
    $(".k-visual").addClass("is-loaded")
    $(".g-box").addClass("is-show")
    $(".g-line").css("opacity", "1")
    $(".bangumi-btn").addClass("is-show")
    await sleep(200)
    $(".kv-gumi-wrap").css("opacity", "1")
    $(".kv-gumi").css("opacity", "1")
  
    const line = new Vivus('line', { type: 'scenario-sync', duration: 40, forceRender: false, animTimingFunction: Vivus.EASE })
    await sleep(600)
    $(".kv-button").addClass("is-affordance")
    await sleep(500)
    $(".p-header-menu").fadeIn(600)
    $(".p-side-bar").fadeIn(600)
    $(".k-visual__logo").css("opacity", 1).on("transitionend", (e) => {
      $(e.target).off("transitionend")
      $(".k-visual").addClass("is-finish")
    })
  })
}






// WEBPACK FOOTER //
// ./src/js/top_kv.js